import ErrorValidation from '../personalized/error-validation'
import { __ } from '../../../locales'
import { TENANTS, auDefaultLinkUrl } from '../../constants'

const urlRegex = new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/)

const LinkFilter = ({ inputs, onInputsChange, required, hidden = false }) => {
    const isAuTenant = inputs?.tenant === TENANTS.AU.name

    // AU regulation: widgets may only use the default landing page or no link at all, so the
    // free-text field becomes a Default/Disabled dropdown that is shown for every AU widget
    // (including the single-specialist case that is otherwise hidden).
    if (isAuTenant) {
        const selectedOption = inputs.linkUrl === auDefaultLinkUrl ? 'default' : 'disabled'
        return (
            <div className={'input-component'}>
                <label>{__('inputs.url.label')}:</label>
                <select
                    className="form-control"
                    value={selectedOption}
                    onInput={(ev) => onInputsChange('linkUrl', ev.target.value === 'default' ? auDefaultLinkUrl : '')}
                >
                    <option value="default">{__('inputs.url.option.default')}</option>
                    <option value="disabled">{__('inputs.url.option.disabled')}</option>
                </select>
            </div>
        )
    }

    if (hidden) {
        return null
    }
    return (
        <div className={'input-component'}>
            <label>{__('inputs.url.label')}:</label>
            <input
                type="text"
                className="form-control"
                value={inputs.linkUrl}
                placeholder={required ? 'Add link here' : __('global.optional')}
                onInput={(ev) => onInputsChange('linkUrl', ev.target.value)}
            />
            {(required && !inputs.linkUrl) || (inputs.linkUrl && !inputs.linkUrl.match(urlRegex)) ? (
                <ErrorValidation text={inputs.linkUrl.match(urlRegex) ? null : 'Invalid url'} />
            ) : null}
        </div>
    );
};

export default LinkFilter;
